import dynamic from 'next/dynamic';

const DynamicTokenAuthHandler = dynamic(
  async () => import('./token-auth-handler').then((m) => m.TokenAuthHandler),
  {
    ssr: false,
    loading: () => null,
  }
);

export { DynamicTokenAuthHandler };
